<script setup lang="ts">
import {ElPopover} from 'element-plus';
import WhiteCircleIcon from '@/views/icons/WhiteCircleIcon.vue';
import GreenCircleIcon from '@/views/icons/GreenCircleIcon.vue';
import OrangeCircleIcon from '@/views/icons/OrangeCircleIcon.vue';
import BlueCircleIcon from '@/views/icons/BlueCircleIcon.vue';
import PurpleCircleIcon from '@/views/icons/PurpleCircleIcon.vue';
import RedCircleIcon from '@/views/icons/RedCircleIcon.vue';
import CalculatorIcon from '@/views/icons/CalculatorIcon.vue';
import HandIcon from '@/views/icons/HandIcon.vue';
import InfoIcon from '@/views/icons/InfoIcon.vue';

function td1(): string {
    return 'pb-2 pt-3 pl-3 pr-0';
}

function td2(): string {
    return 'whitespace-nowrap pr-3 pl-0';
}
</script>

<template>
    <div class="absolute top-0 right-0 pr-8 pt-2 cursor-default">
        <el-popover
            :width="400"
            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 10px;"
        >
            <template #reference>
                <InfoIcon/>
            </template>

            <div class="pb-2">
                Verklaring der symbolen:
            </div>
            <table class="table-auto border-collapse border w-full">
                <tbody>
                <tr>
                    <td :class="td1()">
                        <OrangeCircleIcon/>
                    </td>
                    <td :class="td2()">er moet nog iets ingevuld worden</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <GreenCircleIcon/>
                    </td>
                    <td :class="td2()">item klaar om ingediend te worden</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <BlueCircleIcon/>
                    </td>
                    <td :class="td2()">ingediend item</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <PurpleCircleIcon/>
                    </td>
                    <td :class="td2()">geaccepteerd item</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <RedCircleIcon/>
                    </td>
                    <td :class="td2()">afgewezen item</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <WhiteCircleIcon/>
                    </td>
                    <td :class="td2()">toekomstig item</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <CalculatorIcon/>
                    </td>
                    <td :class="td2()">berekende waarde</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <CalculatorIcon :crippled="true"/>
                    </td>
                    <td :class="td2()">berekende waarde (nog geen expressie)</td>
                </tr>
                <tr>
                    <td :class="td1()">
                        <HandIcon/>
                    </td>
                    <td :class="td2()">berekende status</td>
                </tr>
                </tbody>
            </table>
        </el-popover>
    </div>
</template>
